module.exports = __webpack_public_path__ + "img/csy.aef47e98.jpg";